<template>
  <div class="login-container">
    <div style="text-align: center">
      <p style="font-size: 50px; color: #fff"></p>
    </div>
    <div class="tui-positions">
      <img
        src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-3/20220803145338_7274.png"
        alt=""
      />
      <div>上海市宝山区红星幼儿园</div>
    </div>
    <div class="tui-form">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="title-container">
          <span style="color: #27abf7">红星智慧云</span>
          <span>物联网大数据平台</span>
        </div>
        <div class="tui-loginBox">
          <div class="checkLoginType">
            <div
              @click="checkLoginType(0)"
              :class="[loginForm.loginType == 0 ? 'LoginActive' : '']"
            >
              密码登录 <span></span>
            </div>
            <div
              style="margin-left: 3vw"
              @click="checkLoginType(1)"
              :class="[loginForm.loginType == 1 ? 'LoginActive' : '']"
            >
              免密码登录<span></span>
            </div>
          </div>
          <div class="inputBox">
            <div
              v-if="loginForm.loginType == 1"
              style="
                color: #666;
                font-size: 0.2rem;
                padding-left: 0.25rem;
                line-height: 0.6rem;
                height: 100%;
              "
            >
              中国+86
            </div>
            <!-- <img v-if="loginType == 1" src="/assets/arrowsUpDown.png" alt="" /> -->
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />

            <input
              v-if="loginForm.loginType == 1"
              style="
                height: 100%;
                font-size: 0.2rem;
                color: #333;
                padding-left: 0.15rem;
              "
              placeholder="请输入您的手机号"
              v-model="loginForm.username"
              autoComplete="off"
              type="text"
            />
            <input
              v-if="loginForm.loginType == 0"
              style="
                height: 100%;
                font-size: 0.2rem;
                color: #333;
                padding-left: 0.15rem;
              "
              placeholder="请输入您的账号"
              v-model="loginForm.username"
              autoComplete="off"
              type="text"
            />
          </div>
          <div class="inputBox" v-if="loginForm.loginType == 1">
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />
            <input
              style="
                height: 100%;
                font-size: 0.2rem;
                color: #333;
                padding-left: 0.15rem;
              "
              placeholder="输入6位短信验证码"
              v-model="loginForm.password"
              autoComplete="off"
              type="text"
            />
            <div
              style="color: #27abf7; cursor: pointer; padding-right: 0.25rem"
              @click.stop="getVerifyCode"
            >
              {{ btnTitle }}
            </div>
          </div>
          <div class="inputBox" v-if="loginForm.loginType == 0">
            <input
              type="password"
              style="width: 0; height: 0; border: 0; position: absolute"
              name="xx"
            />
            <input
              style="
                height: 100%;
                font-size: 0.2rem;
                color: #333;
                padding-left: 0.15rem;
              "
              placeholder="请输入密码"
              v-model="loginForm.password"
              autoComplete="off"
              type="password"
            />
          </div>

          <div class="flex-between">
            <el-checkbox v-model="checked">记住我</el-checkbox>
            <div class="passward">找回密码</div>
          </div>
          <!-- 登录 -->
          <el-button
            :loading="loading"
            type="primary"
            style="
              width: 100%;
              margin-top: 0.25rem;
              border-radius: 0.3rem;
              height: 0.6rem;
              background: #27abf7;
            "
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
          <div class="flex-around" style="padding-top: 0.5125rem">
            <div>社交账号登录</div>
            <div
              v-for="(item, index) in loginTypeList"
              :key="index"
              @click="onClickOtherLogin"
            >
              <img :src="item.img" alt="" />
              <div style="font-size: 0.175rem; padding-left: 0.125rem">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div style="text-align: center">
      <p style="font-size: 18px; color: #fff; opacity: 0.5"></p>
      <!-- <img src="../assets/logon.jpg" alt="" /> -->
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";
import {
  requestLogin,
  requestLoginMock,
  getUserByToken,
  getNavigationBar,
} from "../api/api";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        loginType: 0,
      },
      loginRules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      btnTitle: "获取验证码",
      checked: false,
      loginTypeList: [
        {
          img: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-3/20220803144728_3928.png",
          name: "微信",
        },
        {
          img: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-3/20220803144805_5245.png",
          name: "QQ",
        },
        {
          img: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-3/20220803144818_6956.png",
          name: "微博",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    // 外接登录按钮
    onClickOtherLogin() {
      this.$message({
        type: "warning",
        message: "敬请期待",
      });
    },
    checkLoginType(type) {
      this.loginForm.loginType = type;
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    // 验证登录
    SetLogin() {
      if (this.loginForm.loginType == 0) {
        if (this.loginForm.username != "" && this.loginForm.password != "") {
          return true;
        } else {
          this.$message({
            type: "error",
            message: "请输入账号或密码不能为空",
          });
          return false;
        }
      } else if (this.loginForm.loginType == 1) {
        if (this.loginForm.username != "" && this.loginForm.password != "") {
          return true;
        } else {
          this.$message({
            type: "error",
            message: "请输入账号或验证码不能为空",
          });
          return false;
        }
      }
    },
    handleLogin() {
       window.localStorage.loginurl="/hxlogin";
      // 密码登录
      // //console.log(this.SetLogin(), "this.SetLogin()");
      if (this.SetLogin()) {
        var _this = this;
        this.logining = true;
        var loginParams = {
          name: this.loginForm.username,
          pass: this.loginForm.password,
          Code: this.loginForm.password,
          Type: this.loginForm.loginType == 0 ? 1 : 0,
        };

        _this.loginStr = "登录中...";

        requestLogin(loginParams).then((data) => {
          if (!data.success) {
            _this.$message({
              message: data.msg,
              type: "error",
            });
            _this.logining = false;
            _this.loginStr = "重新登录";
          } else {
            var token = data.response.token;
            _this.$store.commit("saveToken", token);
            var curTime = new Date();
            var expiredate = new Date(
              curTime.setSeconds(
                curTime.getSeconds() + data.response.expires_in
              )
            );
            _this.$store.commit("saveTokenExpire", expiredate);
            window.localStorage.refreshtime = expiredate;
            window.localStorage.expires_in = data.response.expires_in;
            _this.getUserInfoByToken(token);
          }
        });
      }
    },
       // 获取用户数据
    getUserInfoByToken(token) {
      var _this = this;
      var loginParams = { token: token };
      getUserByToken(loginParams).then((data) => {
        if (!data.success) {
          _this.$message({
            message: data.msg,
            type: "error",
          });
        } else {
          window.localStorage.user = JSON.stringify(data.response);
          if (data.response.ParentId == -1) {
            this.$router.push({
              path: "/newCharts",
            });
          } else {
            // _this.loginStr = "接收到用户数据，开始初始化路由树...";
            if (data.response.uID > 0) {
              _this.GetNavigationBar(data.response.uID);
            } else {
              _this.$message({
                message: "登录失败",
                type: "error",
              });
              this.loginStr = "重新登录";
            }
          }
        }
      });
    },
    // 获取路由树
    GetNavigationBar(uid) {
      var _this = this;
      // var loginParams = { uid: uid, t: new Date() };
      var loginParams = { uid: uid };
      getNavigationBar(loginParams).then((data) => {
        _this.logining = false;
        if (!data.success) {
          _this.$message({
            message: data.msg,
            type: "error",
          });
          this.loginStr = "重新登录";
        } else {
          // _this.closeAlert()
          _this.$message({
            message: "后台初始化成功",
            type: "success",
          });
          let userinfo = JSON.parse(
            window.localStorage.user ? window.localStorage.user : null
          );
          _this.$notify({
            type: "success",
            message: `登录成功 \n 欢迎管理员：${userinfo.SchoolName}`,
            duration: 6000,
          });
          let getRouter = data.response.children; //后台拿到路由
          window.localStorage.router = JSON.stringify(data.response.children);
          getRouter = filterAsyncRouter(getRouter); //过滤路由
          router.$addRoutes(getRouter); //动态添加路由
          _this.$router.replace("/");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */
.tui-positions {
  position: fixed;
  top: 0.8125rem;
  left: 0.8125rem;
  display: flex;
  align-items: center;
  div {
    font-size: 0.3rem;
    color: #fff;
    padding-left: 0.125rem;
    font-weight: 600;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.26);
  }
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .passward {
    color: #27abf7;
    font-size: 0.175rem;
  }
}
.flex-around {
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
}
.tui-loginBox {
  width: 4.6rem;
  margin: 0 auto;
  .inputBox {
    height: 0.6rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    display: flex;
    align-items: center;

    margin-bottom: 0.1875rem;
    input {
      background: none;
      outline: none;
      border: none;
      flex: 1;
      display: block;
      width: 3vw;
    }
    img {
      width: 8px;
      height: auto;
      display: block;
      margin-left: 20px;
      margin-right: 20px;
    }
    input:focus {
      border: none;
    }
    ::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      font-size: 0.2rem;
      color: #cccccc;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      font-size: 0.2rem;
      color: #cccccc;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      font-size: 0.2rem;
      color: #cccccc;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      font-size: 0.2rem;
      color: #cccccc;
    }
  }
}
.checkLoginType {
  display: flex;
  div {
    position: relative;
    color: #666666;
    font-size: 0.25rem;
    font-weight: 400;
    transition: all 500ms;
    cursor: pointer;
    padding-bottom: 0.5vw;
    margin-bottom: 2vw;
    span {
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      background: #3558b9;
      transform: translateX(-50%);
      transition: width 300ms;
    }
  }
  .LoginActive {
    font-weight: bold;
    color: #333333;
    span {
      width: 0.4625rem;
      height: 0.05rem;
      background: #27abf7;
      border-radius: 2px;
    }
  }
}
@supports (-webkit-mask: none) and (not (cater-color: #fff)) {
  .login-container .el-input input {
    color: #fff;
  }
}
.tui-form {
  width: 6.65rem;
  height: 6.55rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.25rem;
  border: 1px solid #ffffff;
  backdrop-filter: blur(13px);
}
/* reset element-ui css */
.login-container {
  background: url(../assets/bg.png) fixed no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #eee;
      height: 47px;
      caret-color: #fff;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px #2d3a4b inset !important;
        -webkit-text-fill-color: #fff !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="less" scoped>
.login-container {
  min-height: 100%;
  width: 100%;
  background-color: #2d3a4b;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: #889aa4;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    text-align: center;
    padding: 0.625rem 0;
    span {
      font-size: 0.35rem;
      color: #333333;
      font-weight: 600;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: #889aa4;
    cursor: pointer;
    user-select: none;
  }
}
</style>
